import { createContext } from 'react';
import { ICurrencies, IItemForGetShortInfo, TTypeOfServiceProvided, ICreateRestaurant, TPosSystemId } from 'types';

export type TCreateRestaurantSelectedItem = Nullable<string>;
export type TCreateRestaurantSelectedClientType = null | TTypeOfServiceProvided;
export type TCreateRestaurantSelectedPOSType = null | TPosSystemId;
export type TTypeOfCreateRestaurantModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error';

export interface ICreateRestaurantState {
	fetchedCountries: IItemForGetShortInfo[];
	IDSelectedCountry: TCreateRestaurantSelectedItem;
	fetchedCities: IItemForGetShortInfo[];
	IDSelectedCity: TCreateRestaurantSelectedItem;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: TCreateRestaurantSelectedItem;
	clientType: TCreateRestaurantSelectedClientType;
	name: string;
	fetchedCurrencies: ICurrencies[];
	selectedCurrencySymbol: TCreateRestaurantSelectedItem;
	address: string;
	email: string;
	code: Nullable<string>;
	priceType: TCreateRestaurantSelectedItem;
	isUsedCustomerPriceType: boolean;
	IDPosSystem: TCreateRestaurantSelectedPOSType;
	fetchedLanguages: IItemForGetShortInfo[];
	IDSelectedDefaultLanguage: TCreateRestaurantSelectedItem;
	dataForSubmit: ICreateRestaurant | null;
	typeOfModalWindow: TTypeOfCreateRestaurantModalWindow;
}

export const createRestaurantInitialState: ICreateRestaurantState = {
	fetchedCountries: [],
	IDSelectedCountry: null,
	fetchedCities: [],
	IDSelectedCity: null,
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	clientType: null,
	name: '',
	fetchedCurrencies: [],
	selectedCurrencySymbol: null,
	address: '',
	email: '',
	code: '',
	priceType: null,
	isUsedCustomerPriceType: true,
	IDPosSystem: null,
	fetchedLanguages: [],
	IDSelectedDefaultLanguage: null,
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateRestaurantContext extends ICreateRestaurantState {
	setFetchedCountries(value: IItemForGetShortInfo[]): void;
	setIDCountry(value: TCreateRestaurantSelectedItem): void;
	setFetchedCities(value: IItemForGetShortInfo[]): void;
	setIDCity(value: TCreateRestaurantSelectedItem): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: TCreateRestaurantSelectedItem): void;
	setClientType(value: TCreateRestaurantSelectedClientType): void;
	changeName(value: string): void;
	setFetchedCurrencies(value: ICurrencies[]): void;
	setCurrencySymbol(value: TCreateRestaurantSelectedItem): void;
	changeAddress(value: string): void;
	changeEmail(value: string): void;
	changeCode(value: string): void;
	changePriceType(value: TCreateRestaurantSelectedItem): void;
	toggleIsUsedCustomerPriceType(): void;
	setIDPosSystem(value: TCreateRestaurantSelectedPOSType): void;
	setFetchedLanguages(value: IItemForGetShortInfo[]): void;
	setIDDefaultLanguage(value: TCreateRestaurantSelectedItem): void;
	setDataForSubmit(data: ICreateRestaurant | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateRestaurantModalWindow): void;
	resetFields(): void;
}

export const CreateRestaurantContext = createContext<ICreateRestaurantContext>({
	setFetchedCountries: () => undefined,
	setIDCountry: () => undefined,
	setFetchedCities: () => undefined,
	setIDCity: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setClientType: () => undefined,
	changeName: () => undefined,
	setFetchedCurrencies: () => undefined,
	setCurrencySymbol: () => undefined,
	changeAddress: () => undefined,
	changeEmail: () => undefined,
	changeCode: () => undefined,
	changePriceType: () => undefined,
	toggleIsUsedCustomerPriceType: () => undefined,
	setIDPosSystem: () => undefined,
	setFetchedLanguages: () => undefined,
	setIDDefaultLanguage: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createRestaurantInitialState,
});
